// extracted by mini-css-extract-plugin
module.exports = {"third":"Gallery-module--third--pUgjs","half":"Gallery-module--half--2tUZJ"};